import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { SelectionEffects } from './selection.effects';
import { selectionReducer } from './selection.reducer';

/**
 * Standalone providers for the `selectionOptions` NgRx feature slice
 * (SEOMS-437). Replaces the former `SelectionStoreModule`.
 */
export function provideSettingsStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('selectionOptions', selectionReducer),
    provideEffects([SelectionEffects]),
  ]);
}
